import { type PropsWithChildren, useState } from 'react';
import clsx from 'clsx';

import { type BookmakersConfig } from '@cx-modules/types';

import {
  GridTable,
  PerformanceIndicator,
  useToggle } from
'~/components/OddscheckerPlus/components/cxy';
import { type BettingInsights } from '~/configuration/betting-insights/BettingInsightsConfig';
import {
  type BettingInsightsContent,
  type PositiveEvIndex,
  type ValueBetResult } from
'~/configuration/betting-insights/types';
import {
  type BettingInsightsUI,
  type StyleSheet } from
'~/configuration/betting-insights/ui/BettingInsightsUI';
import type ODDS_FORMAT from '~/enums/odds_format';

import { DefaultTableBody } from '../DefaultTableBody';
import { EventDetails } from '../EventDetails';

import styles from './styles/PositiveEv.module.css';

const PositiveEv = ({
  children,
  config,
  content,
  result




}: {config: BettingInsights<PositiveEvIndex>;content: BettingInsightsContent<PositiveEvIndex>[];result: ValueBetResult;} & PropsWithChildren) => {
  return (
    <GridTable
      className={styles.positiveValue}
      label={result.subeventName}
      mobileColumns={3}>

			<GridTable.Caption>
				<EventDetails<PositiveEvIndex>
          content={content}
          renderTitle={config.ui.card.title.render}
          result={result} />

			</GridTable.Caption>
			{children}
		</GridTable>);

};

export function PositiveEvBody({
  bookmakers,
  content,
  label,
  oddsFormat,
  resultIndex,
  styles,
  table








}: {bookmakers: BookmakersConfig;content: ValueBetResult;label: string;oddsFormat: ODDS_FORMAT;resultIndex: number;styles: StyleSheet;table: BettingInsightsUI<PositiveEvIndex>['card']['table'];}) {
  return (
    <DefaultTableBody
      bookmakers={bookmakers}
      content={content}
      label={label}
      oddsFormat={oddsFormat}
      resultIndex={resultIndex}
      styles={styles}
      table={table} />);


}

export function PositiveEvFooter({
  content,
  formatDate



}: {content: ValueBetResult;formatDate: (date: string, format?: string) => string;}) {
  const [isOpen, setIsOpen] = useState(true);
  const { Indicator, headingProps, sectionProps, triggerClass } = useToggle({
    isOpen,
    onChange: setIsOpen
  });

  if (!content.sportsData?.history) {
    return null;
  }

  const lastTenResults = content.sportsData.history.slice(0, 10);

  return (
    <GridTable.Footer
      className={styles.footer}
      style={{ gridColumn: '1 / -1' }}>

			<GridTable.Row className={styles.footerRow}>
				<GridTable.Cell
          {...sectionProps}
          alignItems="flex-start"
          className={clsx(
            styles.footerCell,
            styles.footerSection,
            sectionProps.className
          )}>

					{content.betDescription}
				</GridTable.Cell>
				<GridTable.Cell
          {...headingProps}
          className={clsx(
            styles.indicatorCell,
            styles.footerCell,
            triggerClass
          )}>

					<PerformanceIndicator
            formatDate={formatDate}
            history={lastTenResults}
            hitRate={content.sportsData.hitRates.last10}
            showMatchInformation={isOpen} />

					<span className={styles.indicator}>
						<Indicator />
					</span>
				</GridTable.Cell>
			</GridTable.Row>
		</GridTable.Footer>);

}

PositiveEv.Body = PositiveEvBody;
PositiveEv.Footer = PositiveEvFooter;

export { PositiveEv };